// Copyright (c) StrangeBee 2023

import React, { ReactElement } from 'react';
import { IsIgnoreSimilarity } from '@Organisms/IsIgnoreSimilarity/IsIgnoreSimilarity';
import { IsSeen } from '@Organisms/IsSeen/IsSeen';
import { PAPValues, TLPValues } from 'thehive-sdk';
import { SecurityTag } from '@Atoms/Info';
import { IsIoc } from '@Organisms/IsIoc/IsIoc';
import { IsSighted } from '@Organisms/IsSighted/IsSighted';

import './ObservableListStatus.scss';

interface ObservableListStatusProps {
    values: {
        tlp: TLPValues;
        pap: PAPValues;
        ioc: boolean;
        sighted: boolean;
        ignoreSimilarity: boolean;
        seen?: boolean;
        seenIoc?: boolean;
        seenEstimate?: string;
    };
    onStatusClick?: {
        onTLPClick: () => void;
        onPAPClick: () => void;
        onIOCClick: () => void;
        onSightedClick: () => void;
        onSimilarityClick: () => void;
    };
}

export const ObservableListStatus = ({
    values: { tlp, pap, ignoreSimilarity, ioc, seen, sighted, seenIoc, seenEstimate },
    onStatusClick,
}: ObservableListStatusProps): ReactElement => {
    const { onTLPClick, onPAPClick, onIOCClick, onSightedClick, onSimilarityClick } = onStatusClick || {};

    return (
        <div className="observable-list-status">
            <div className="observable-list-status__column">
                <SecurityTag type="tlp" value={tlp} onClick={onTLPClick} className="observable-list-status__tlp" />
                <SecurityTag type="pap" value={pap} onClick={onPAPClick} className="observable-list-status__tlp" />
            </div>
            <div className="observable-list-status__row">
                <IsIoc value={ioc} onClick={onIOCClick} />
                <IsSighted value={sighted} onClick={onSightedClick} />
                {seen !== undefined ? <IsSeen value={seen} isIoc={seenIoc} seenEstimate={seenEstimate} /> : null}
                <IsIgnoreSimilarity value={ignoreSimilarity} onClick={onSimilarityClick} />
            </div>
        </div>
    );
};
